(function () {
  const initMegaMenu = (header) => {
    const headerLinks = header.querySelectorAll(".header__menu-item");
    const templates = document.querySelectorAll(".mega-menu-template");
    if (!headerLinks.length || !templates.length) {
      return;
    }
    headerLinks.forEach((link) => {
      const handle = link.dataset.handle;
      if (!handle) return;
      const template = Array.from(templates).find(
        (template) => template.dataset.trigger === handle
      );
      if (!template) return;
      const cloned = template.content.firstElementChild?.cloneNode(true);
      if (!cloned) return;
      const parent = link.parentElement;
      parent.classList.remove("list-menu--submenu");
      parent.classList.add("list-menu--megamenu");
      const next = link.nextElementSibling;
      if (
        next?.classList.contains("header__submenu") ||
        next?.tagName === "MEGA-MENU" ||
        next?.tagName === "MEGA-MENU-TABS"
      ) {
        next.replaceWith(cloned);
      } else {
        link.insertAdjacentElement("afterend", cloned);
      }
    });
  };
  const closeMobileMenu = (header) => {
    const menuCloseBtn = header.querySelector(".header__modal-close-button");
    const mobileMenuDrawer = header.querySelector("header-drawer");
    menuCloseBtn?.addEventListener("click", (e) => {
      mobileMenuDrawer.closeMenuDrawer(e);
    });
  };
  const initHeader = () => {
    const header = document.querySelector(".shopify-section-header");
    if (!header) return;
    const openAllButtons = header.querySelectorAll(".js-open-list-menu-item");
    openAllButtons.forEach((button) => {
      button.addEventListener("click", (event) => {
        const submenu = event.currentTarget.closest(".header__submenu");
        const items = submenu.querySelectorAll(".header__submenu-li");
        items.forEach((item) => {
          item.classList.add("active");
        });
        event.currentTarget.parentElement.classList.add("hide");
      });
    });
    initMegaMenu(header);
    closeMobileMenu(header);
  };
  initHeader();
  document.addEventListener("shopify:section:load", initHeader);
  document.addEventListener("shopify:section:unload", initHeader);
  document.addEventListener("shopify:section:reorder", initHeader);
})();
class BurgerMenu extends HTMLElement {
  constructor() {
    super();
    this.header = document.querySelector(".header-wrapper");
    this.headerLogo = this.header.querySelector(".header__heading-link");
    this.burgerMenu = this.querySelector(".burger-menu");
    this.openBtn = this.querySelector(".burger-menu__open");
    this.closeBtn = this.querySelector(".burger-menu__close");
    this.openSubmenuIcons = this.querySelectorAll(
      ".burger-menu__menu-list--submenu .icon-arrow-down"
    );
    if (this.header) this.header.preventHide = false;
    this.setListeners();
  }
  open() {
    if (this.header) this.header.preventHide = true;
    this.setAttribute("opened", "true");
    document.body.classList.add("overflow-hidden-drawer");
    this.burgerMenu?.addEventListener("transitionend", () => trapFocus(this), {
      once: true,
    });
  }
  close() {
    document.body.classList.remove("overflow-hidden-drawer");
    this.removeAttribute("opened");
    if (this.header) this.header.preventHide = false;
  }
  disconnectedCallback() {
    if (this.handleEscape) {
      document.removeEventListener("keydown", this.handleEscape);
    }
  }
  setListeners() {
    this.openBtn?.addEventListener("click", (e) => {
      this.open(e);
    });
    this.closeBtn?.addEventListener("click", () => {
      this.close();
    });
    this.handleEscape = (event) => {
      if (event.key === "Escape" && this.hasAttribute("opened")) {
        this.close();
      }
    };
    document.addEventListener("keydown", this.handleEscape);
    this.openSubmenuIcons?.forEach((icon) => {
      icon.setAttribute("tabindex", "0");
      const handleClick = (event) => {
        event.preventDefault();
        const item = icon.closest("li");
        const submenu = item.querySelector(".burger-menu__submenu");
        if (submenu.classList.contains("active")) {
          item.classList.remove("open");
          submenu?.classList.remove("active");
        } else {
          item.classList.add("open");
          submenu?.classList.add("active");
        }
      };
      icon.addEventListener("click", handleClick);
      icon.addEventListener("keydown", (event) => {
        if (event.key === "Enter" || event.key === " ") {
          handleClick(event);
        }
      });
    });
    const resizeObserver = new ResizeObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.contentRect.width < 1100) {
          this.close();
        }
      });
    });
    resizeObserver.observe(this);
  }
}
if (!customElements.get("burger-menu")) {
  customElements.define("burger-menu", BurgerMenu);
}
class HeaderSearch extends HTMLElement {
  constructor() {
    super();
    this.header = document.querySelector(".header-wrapper");
    this.searchLink = this.querySelector(".header__icon--search");
    this.closeButton = this.querySelector(".header__search-close");
    this.overlayEl = this.querySelector(".header__search-overlay");
    this.modalContainer = this.querySelector(".header__search-inner");
    this.popularProductsContainer = this.querySelector(
      ".header__search-products"
    );
    this.searchInput = this.querySelector("#Search-In-Modal");
    this.open = this.onOpen.bind(this);
    this.close = this.onClose.bind(this);
    this.handleKeyDown = this.onHandleKeyDown.bind(this);
    this.searchLink?.addEventListener("click", this.open);
    this.closeButton?.addEventListener("click", (event) => {
      event.preventDefault();
      event.stopPropagation();
      this.close();
    });
    this.overlayEl?.addEventListener("click", this.close);
    this.header?.addEventListener("keydown", this.handleKeyDown);
    this._heightCalculated = false;
    let resizeTimer;
    window.addEventListener("resize", () => {
      if (!this._heightCalculated) return;
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => {
        const predictiveSearch = this.querySelector("predictive-search");
        if (predictiveSearch && predictiveSearch.getAttribute("open")) {
          this.calculatePredictiveSearchHeight();
        } else {
          this.calculateOptimalHeight();
        }
      }, 150);
    });
  }
  calculateOptimalHeight() {
    if (window.innerWidth < 990 || !this.popularProductsContainer) return;
    const productCards = Array.from(
      this.popularProductsContainer.querySelectorAll(".card-small")
    ).slice(0, 3);
    if (!productCards.length) return;
    this.setOptimalHeight(productCards);
  }
  setOptimalHeight(productCards) {
    const maxCardHeight = Math.max(
      ...productCards.map((card) => card.getBoundingClientRect().height)
    );
    const searchHeading = this.querySelector(".header__search-heading");
    const searchFormInner = this.querySelector(".search__form-inner");
    const headingHeight = searchHeading
      ? searchHeading.getBoundingClientRect().height
      : 0;
    const formHeight = searchFormInner
      ? searchFormInner.getBoundingClientRect().height
      : 0;
    const popularHeadings = this.querySelectorAll(".header__search-subtitle");
    const popularHeadingHeight = popularHeadings?.length
      ? Math.max(
          ...Array.from(popularHeadings).map(
            (heading) => heading.getBoundingClientRect().height + 12
          )
        )
      : 0; // 12px is row-gap
    const containerPadding = 64; // 3.2rem top + 3.2rem bottom
    const requiredHeight =
      headingHeight +
      formHeight +
      popularHeadingHeight +
      maxCardHeight +
      containerPadding;
    let requiredHeightRem = requiredHeight / 10;
    const maxHeightVh = window.innerHeight * 0.9;
    const maxHeightRem = maxHeightVh / 10;
    if (requiredHeightRem > maxHeightRem) {
      requiredHeightRem = maxHeightRem;
    }
    if (window.innerWidth >= 990) {
      this.style.setProperty(
        "--header-search-height",
        `${requiredHeightRem}rem`
      );
    }
  }
  calculatePredictiveSearchHeight() {
    if (window.innerWidth < 990) return;
    const predictiveSearch = this.querySelector("predictive-search");
    if (!predictiveSearch || !predictiveSearch.getAttribute("open")) {
      this.calculateOptimalHeight();
      return;
    }
    const searchHeading = this.querySelector(".header__search-heading");
    const searchFormInner = this.querySelector(".search__form-inner");
    const headingHeight = searchHeading
      ? searchHeading.getBoundingClientRect().height
      : 0;
    const formHeight = searchFormInner
      ? searchFormInner.getBoundingClientRect().height
      : 0;
    let contentHeight = 0;
    let tabsHeight = 0;
    const emptyState = predictiveSearch.querySelector(
      ".predictive-search__empty"
    );
    if (emptyState) {
      contentHeight = emptyState.scrollHeight + 32;
    } else {
      const activeResultsList = predictiveSearch.querySelector(
        ".predictive-search__results-list.active"
      );
      if (!activeResultsList) {
        this.calculateOptimalHeight();
        return;
      }
      const resultsTabs = predictiveSearch.querySelector(
        ".predictive-search__result-tabs"
      );
      tabsHeight = resultsTabs ? resultsTabs.getBoundingClientRect().height : 0;
      contentHeight = activeResultsList.scrollHeight;
    }
    const containerPadding = 32; // 3.2rem bottom
    const totalHeight =
      headingHeight +
      formHeight +
      tabsHeight +
      contentHeight +
      containerPadding;
    let heightRem = totalHeight / 10;
    const maxHeightVh = window.innerHeight * 0.9;
    const maxHeightRem = maxHeightVh / 10;
    if (heightRem > maxHeightRem) {
      heightRem = maxHeightRem;
    }
    if (window.innerWidth >= 990) {
      this.style.setProperty("--header-search-height", `${heightRem}rem`);
    }
  }
  onOpen(event) {
    event.preventDefault();
    if (!this._heightCalculated) {
      this._heightCalculated = true;
      this.calculateOptimalHeight();
    }
    if (this.header) this.header.preventHide = true;
    this.setAttribute("open", true);
    document.body.classList.add("overflow-hidden-search");
    requestAnimationFrame(() => {
      this.setupTrapFocus();
    });
  }
  setupTrapFocus() {
    removeTrapFocus();
    const getVisibleFocusableElements = () => {
      const allElements = Array.from(
        this.modalContainer.querySelectorAll(
          "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
        )
      );
      return allElements.filter((el) => {
        const rect = el.getBoundingClientRect();
        const style = window.getComputedStyle(el);
        return (
          rect.width > 0 &&
          rect.height > 0 &&
          style.visibility !== "hidden" &&
          style.display !== "none"
        );
      });
    };
    this.trapFocusInHandler = (event) => {
      if (!this.modalContainer.contains(event.target)) {
        event.preventDefault();
        event.stopPropagation();
        const elements = getVisibleFocusableElements();
        if (elements.length > 0) {
          elements[0].focus();
        }
      }
    };
    document.addEventListener("focusin", this.trapFocusInHandler, true);
    requestAnimationFrame(() => {
      this.searchInput?.focus();
    });
  }
  onClose() {
    this.removeAttribute("open");
    if (this.header) this.header.preventHide = false;
    document.body.classList.remove("overflow-hidden-search");
    if (this.trapFocusHandler) {
      document.removeEventListener("keydown", this.trapFocusHandler);
      this.trapFocusHandler = null;
    }
    removeTrapFocus();
    this.modalContainer.addEventListener(
      "transitionend",
      () => {
        if (this.searchLink) this.searchLink.focus();
      },
      { once: true }
    );
  }
  onHandleKeyDown(event) {
    if (this.getAttribute("open")) {
      if (event.key === "Escape") {
        this.close();
      }
    }
  }
  disconnectedCallback() {
    this.header.removeEventListener("keydown", this.handleKeyDown);
  }
}
if (!customElements.get("header-search")) {
  customElements.define("header-search", HeaderSearch);
}
class MegaMenu extends HTMLElement {
  constructor() {
    super();
    this.productsSliderEl = this.querySelector(".mega-menu-products-slider");
    this.nav = this.querySelector(".mega-menu-products-nav");
    this.productsSlider = null;
    this.openBtn = this.closest(".list-menu--megamenu");
    this.header = document.querySelector(".header-wrapper");
    this.openedViaHover = false;
    this.handleResize = this.handleResize.bind(this);
  }
  connectedCallback() {
    this.initProductsSlider();
    this.positionProductsSliderNav();
    this.calcHeight();
    this.openBtn.addEventListener("mouseenter", () => {
      this.openedViaHover = true;
      document.body.classList.add("overflow-hidden");
      this.header.preventHide = true;
    });
    this.openBtn.addEventListener("focus", () => {
      this.openedViaHover = false;
      document.body.classList.add("overflow-hidden");
      this.header.preventHide = true;
    });
    this.openBtn.addEventListener("mouseleave", () => {
      this.openedViaHover = false;
      document.body.classList.remove("overflow-hidden");
      this.header.preventHide = false;
    });
    this.openBtn.addEventListener("blur", () => {
      document.body.classList.remove("overflow-hidden");
      this.header.preventHide = false;
    });
    this.addEventListener("focusin", (e) => {
      if (this.openedViaHover && e.target !== this.openBtn) {
        e.preventDefault();
        e.stopPropagation();
        const currentFocus = document.activeElement;
        if (currentFocus && this.contains(currentFocus)) {
          currentFocus.blur();
        }
      }
    });
    this.resizeObserver = new ResizeObserver(() => {
      clearTimeout(this.resizeTimeout);
      this.resizeTimeout = setTimeout(this.handleResize, 100);
    });
    this.resizeObserver.observe(this);
  }
  disconnectedCallback() {
    if (this.productsSlider) {
      this.productsSlider.destroy(true, true);
      this.productsSlider = null;
    }
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
      this.resizeObserver = null;
    }
    clearTimeout(this.resizeTimeout);
  }
  initProductsSlider = () => {
    if (!this.productsSliderEl || this.productsSlider) {
      return;
    }
    const slidesPerViewLg = this.productsSliderEl.dataset.spvLg;
    const slidesPerViewXl = this.productsSliderEl.dataset.spvXl;
    const slidesPerViewXxl = this.productsSliderEl.dataset.spvXxl;
    let breakpoints = {
      990: {
        slidesPerView: slidesPerViewLg,
        spaceBetween: 20,
      },
      1360: {
        slidesPerView: slidesPerViewXl,
        spaceBetween: 24,
      },
      1536: {
        slidesPerView: slidesPerViewXxl,
        spaceBetween: 24,
      },
    };
    this.productsSlider = new Swiper(this.productsSliderEl, {
      slidesPerView: 3,
      spaceBetween: 20,
      speed: 1000,
      loop: false,
      watchOverflow: true,
      allowTouchMove: true,
      mousewheel: {
        forceToAxis: true,
      },
      breakpoints: breakpoints,
      navigation: {
        prevEl: this.querySelector(".mega-menu-products-nav-button--prev"),
        nextEl: this.querySelector(".mega-menu-products-nav-button--next"),
      },
    });
  };
  positionProductsSliderNav() {
    if (!this.nav) return;
    const firstSlide = this.querySelector(".mega-menu-products-slide");
    if (!firstSlide) return;
    const imgWrapper = firstSlide.querySelector(
      ".card-small-image-link-wrapper"
    );
    if (!imgWrapper) return;
    const imgRect = imgWrapper.getBoundingClientRect();
    const offsetY = (imgRect.height - this.nav.offsetHeight) / 2;
    this.nav.style.top = `${Math.max(offsetY, 0)}px`;
    this.nav.style.transform = "none";
    this.nav.classList.add("mega-menu-products-nav--visible");
  }
  calcHeight() {
    if (!this.productsSliderEl) return;
    const productsHeight = this.productsSliderEl.offsetHeight;
    this.style.setProperty(
      "--products-height-with-padding",
      `${productsHeight + 52}px`
    );
    this.style.setProperty("--products-height", `${productsHeight + 4}px`);
  }
  handleResize() {
    this.calcHeight();
    this.positionProductsSliderNav();
  }
}
if (!customElements.get("mega-menu")) {
  customElements.define("mega-menu", MegaMenu);
}
class MegaMenuTabs extends HTMLElement {
  constructor() {
    super();
    this.tabs = [];
    this.tabButtons = [];
    this.openBtn = this.closest(".list-menu--megamenu");
    this.header = document.querySelector(".header-wrapper");
    this.openedViaHover = false;
    this.onOpen = this.onOpen.bind(this);
    this.onClose = this.onClose.bind(this);
  }
  connectedCallback() {
    this.setListeners();
    this.initTabs();
    this.calcWidth();
    requestAnimationFrame(() => {
      this.calcPosition();
    });
  }
  disconnectedCallback() {
    if (this.productsSlider) {
      this.productsSlider.destroy(true, true);
      this.productsSlider = null;
    }
    clearTimeout(this.resizeTimeout);
  }
  initTabs() {
    this.tabButtons = this.querySelectorAll(".mega-menu-tabs-nav-list__tab");
    this.tabs = this.querySelectorAll(".mega-menu-tab");
    const tabButtonsArr = Array.from(this.tabButtons);
    const tabsArr = Array.from(this.tabs);
    const onTabClick = (e) => {
      const tabId = e.currentTarget.dataset.tabId;
      this.tabButtons.forEach((button) => {
        button.classList.remove("active");
      });
      this.tabs.forEach((submenu) => {
        submenu.classList.remove("active");
        const submenuId = submenu.id;
        if (submenuId === tabId) {
          submenu.classList.add("active");
        }
      });
      e.currentTarget.classList.add("active");
    };
    this.tabButtons.forEach((tabBtn) => {
      tabBtn.addEventListener("click", onTabClick);
      tabBtn.addEventListener("focus", onTabClick);
      tabBtn.addEventListener("mouseenter", onTabClick);
    });
    this.tabButtons.forEach((btn, idx) => {
      btn.addEventListener("keydown", (e) => {
        if (e.key === "Tab" && !e.shiftKey) {
          e.preventDefault();
          const panel = tabsArr.find((panel) => panel.id === btn.dataset.tabId);
          const first = panel?.querySelector(
            "a, button, input, select, textarea"
          );
          const nextFocus =
            first ||
            this.tabButtons[idx + 1] ||
            this.promoCodeButton ||
            this.button;
          nextFocus.focus();
        }
      });
    });
    const getNextButtonToFocus = (submenuId) => {
      const currentBtn = tabButtonsArr.find(
        (btn) => btn.dataset.tabId === submenuId
      );
      const nextItem = currentBtn?.closest(
        ".mega-menu-tabs-nav-list__item"
      )?.nextElementSibling;
      const nextTab = nextItem?.querySelector(".mega-menu-tabs-nav-list__tab");
      if (!nextTab) {
        const mainMenuList = this.openBtn.closest("ul");
        const currentMenuItem = this.openBtn.closest("li");
        const nextMenuItem = currentMenuItem?.nextElementSibling;
        if (nextMenuItem) {
          const nextFocusable = nextMenuItem.querySelector("a, button");
          return nextFocusable;
        }
        return null;
      }
      return nextTab;
    };
    this.tabs.forEach((panel) => {
      const focusables = Array.from(
        panel.querySelectorAll(
          "a:not([aria-disabled]), button:not([aria-disabled]), input, select, textarea"
        )
      ).filter((el) => !el.disabled);
      if (!focusables.length) return;
      const last = focusables[focusables.length - 1];
      last.addEventListener("keydown", (e) => {
        if (e.key === "Tab" && !e.shiftKey) {
          const nextBtn = getNextButtonToFocus(panel.id);
          if (nextBtn) {
            e.preventDefault();
            nextBtn.focus();
          }
        }
      });
    });
  }
  calcWidth() {
    const tabNavs = this.querySelectorAll(".mega-menu-tab-nav__list");
    const horizontalPaddingsInPX = 50;
    let tabWidth = 520;
    tabNavs.forEach((tab) => {
      const currTabWidth = tab.offsetWidth;
      if (currTabWidth > tabWidth) {
        tabWidth = currTabWidth;
      }
    });
    this.style.setProperty(
      "--tab-width",
      `${(tabWidth + horizontalPaddingsInPX) / 10}rem`
    );
    tabNavs.forEach((tab) => {
      tab.style.width = "100%";
    });
  }
  checkOverflow() {
    const tabsNav = this.querySelector(".mega-menu-tabs-nav");
    const tabsNavList = this.querySelector(".mega-menu-tabs-nav-list");
    if (!tabsNav) return;
    const hasOverflow = tabsNavList.scrollHeight > tabsNavList.clientHeight;
    if (hasOverflow) {
      tabsNav.style.setProperty("--padding-overflow", "0.8rem");
    } else {
      tabsNav.style.setProperty("--padding-overflow", "0rem");
    }
  }
  calcPosition() {
    const windowWidth = document.documentElement.clientWidth;
    const margin = 26;
    const isRTL = document.documentElement.dir === "rtl";
    this.style.left = "";
    this.style.right = "";
    const newRect = this.getBoundingClientRect();
    if (isRTL) {
      if (newRect.left < 0) {
        const offset = Math.abs(newRect.left) + margin;
        this.style.right = `${offset}px`;
      }
      const finalRect = this.getBoundingClientRect();
      if (finalRect.right > windowWidth) {
        this.style.right = `0px`;
      }
    } else {
      if (newRect.right > windowWidth) {
        const offset = windowWidth - newRect.right - margin;
        this.style.left = `${offset}px`;
      }
      const finalRect = this.getBoundingClientRect();
      if (finalRect.left < 0) {
        this.style.left = `0px`;
      }
    }
  }
  onOpen() {
    document.body.classList.add("overflow-hidden");
    this.header.preventHide = true;
    this.calcPosition();
    this.checkOverflow();
  }
  onClose() {
    document.body.classList.remove("overflow-hidden");
    this.header.preventHide = false;
  }
  setListeners() {
    this.openBtn.addEventListener("mouseenter", () => {
      this.openedViaHover = true;
      this.onOpen();
    });
    this.openBtn.addEventListener("focus", () => {
      this.openedViaHover = false;
      this.onOpen();
    });
    this.openBtn.addEventListener("mouseleave", () => {
      this.openedViaHover = false;
      this.onClose();
    });
    this.openBtn.addEventListener("blur", () => {
      this.onClose();
    });
    this.addEventListener("focusin", (e) => {
      if (this.openedViaHover && e.target !== this.openBtn) {
        e.preventDefault();
        e.stopPropagation();
        const currentFocus = document.activeElement;
        if (currentFocus && this.contains(currentFocus)) {
          currentFocus.blur();
        }
      }
    });
  }
}
if (!customElements.get("mega-menu-tabs")) {
  customElements.define("mega-menu-tabs", MegaMenuTabs);
}
